import api from "../../utils/apiUserCliente";

const BASE_URL = "/api/cliente/perfil";

export const getPerfilCliente = async () => {
  const res = await api.get(`${BASE_URL}/obtener`);
  return res.data;
};

export const updatePerfilCliente = async (payload) => {
  const res = await api.put(`${BASE_URL}/actualizar`, payload);
  return res.data;
};

export const changePasswordCliente = async (payload) => {
  const res = await api.put(`${BASE_URL}/actualizar/password`, payload);
  return res.data;
};